import React from "react";
import JalRoLayout from "../components/JalRoLayout";
import {
  ContactCtaSection,
  PageHero,
  ProcessSection,
  ServicesSection,
} from "../components/JalRoSections";

const ServicePage = () => (
  <JalRoLayout>
    <PageHero
      title="RO Services"
      text="Installation, repair, AMC, maintenance, filter replacement, membrane replacement, UV replacement, TDS adjustment, and leakage repair."
    />
    <ServicesSection showAll />
    <ProcessSection />
    <ContactCtaSection />
  </JalRoLayout>
);

export default ServicePage;
